import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { FileText, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const CGV = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="pt-32 pb-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {/* Back Button */}
            <Link 
              to="/"
              className="inline-flex items-center text-emerald-700 hover:text-emerald-800 mb-8 font-medium transition-colors duration-300"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Retour à l'accueil
            </Link>

            {/* Header */}
            <div className="bg-gradient-to-br from-emerald-700 to-emerald-900 p-8 rounded-2xl text-white mb-12 text-center">
              <FileText className="w-16 h-16 mx-auto mb-4" />
              <h1 className="text-3xl sm:text-4xl font-bold mb-2">
                CONDITIONS GÉNÉRALES DE VENTE
              </h1>
              <p className="text-emerald-100">THE HIDDEN GARDEN EMS</p>
            </div>

            {/* Content */}
            <div className="prose prose-lg max-w-none">
              <div className="space-y-8">
                {/* Section 1 */}
                <section className="bg-emerald-50/50 p-6 rounded-xl border border-emerald-100">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Horaires d'ouverture</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Le centre The Hidden Garden EMS est ouvert du lundi au samedi. 
                    Les horaires spécifiques d'ouverture/fermeture ainsi que le jour de repos sont disponibles sur demande ou consultables directement au centre.
                  </p>
                </section>

                {/* Section 2 */}
                <section className="bg-white p-6 rounded-xl border border-gray-200">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Abonnements EMS</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Les abonnements EMS sont souscrits pour une durée minimale de six (6) mois avec reconduction tacite, 
                    sauf résiliation par le client selon les conditions mentionnées dans le contrat.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Les clients abonnés et les clients en Pack sans engagement doivent réserver leurs séances mensuelles avant la fin du mois en cours. 
                    En cas de non-réservation ou d'absence non justifiée (arrêt médical, attestation de déplacement professionnel, justificatif de vacances), 
                    les séances non effectuées seront perdues et non récupérables.
                  </p>
                </section>

                {/* Section 3 */}
                <section className="bg-emerald-50/50 p-6 rounded-xl border border-emerald-100">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Packs de séances EMS</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Les clients qui achètent des packs de séances EMS (sans engagement) doivent utiliser leurs séances dans les délais suivants :
                  </p>
                  <ul className="space-y-2 text-gray-700 ml-6">
                    <li className="list-disc">Forfait 4 séances : 1 mois après la signature du contrat/inscription.</li>
                    <li className="list-disc">Forfait 8 séances : 1 mois après la signature du contrat/inscription.</li>
                    <li className="list-disc">Forfait 12 séances : 1 mois après la signature du contrat/inscription.</li>
                  </ul>
                  <p className="text-gray-700 leading-relaxed mt-4">
                    Sauf en cas d'arrêt médical, attestation de déplacement professionnel, justificatif de vacances pour la durée indiquée sur celui-ci.
                  </p>
                </section>

                {/* Section 4 */}
                <section className="bg-white p-6 rounded-xl border border-gray-200">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Annulation des séances</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Le client doit informer le centre de toute annulation de séance au moins 24 heures avant l'heure prévue. 
                    Si cette condition n'est pas respectée, la séance sera automatiquement déduite du forfait, 
                    sauf en cas de justificatif valable (travail, santé, transport).
                  </p>
                </section>

                {/* Section 5 */}
                <section className="bg-amber-50 p-6 rounded-xl border border-amber-200">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Retards et ponctualité</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Les retards de plus de dix (10) minutes ne sont pas tolérés.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    <strong>Exemple :</strong> Si une séance est programmée à 12h00, le client doit être prêt à commencer à 12h00. 
                    Un retard de 10 minutes équivaut à la moitié d'une séance.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Au-delà de 12h10, afin de ne pas perturber le planning et de garantir le bon déroulement des séances suivantes, 
                    la séance sera automatiquement annulée et déduite du forfait, sauf en cas de circonstances exceptionnelles 
                    dûment justifiées et signalées au coach à l'avance.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Cette règle vise à éviter les retards répétés et à préserver le confort de l'ensemble des clients. 
                    Nous sommes bien conscients que des imprévus peuvent survenir : dans ce cas, il est important d'appeler 
                    le coach le plus tôt possible afin qu'elle puisse vous proposer un autre créneau, dans la mesure du possible, 
                    sans perturber l'organisation du planning.
                  </p>
                </section>

                {/* Section 6 */}
                <section className="bg-white p-6 rounded-xl border border-gray-200">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Tenue EMS</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Pour les coachings EMS, l'achat d'une tenue individuelle est obligatoire dès lors que le client achète un pack ou un abonnement. 
                    Le client doit porter sa tenue EMS pour chaque séance.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    En cas d'oubli, il est possible de louer une tenue sur place pour un coût de cinq (5) euros. 
                    Si le client refuse de louer une tenue, la séance sera déduite du forfait car elle ne peut pas se dérouler sans la tenue appropriée.
                  </p>
                </section>

                {/* Section 7 */}
                <section className="bg-emerald-50/50 p-6 rounded-xl border border-emerald-100">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Hygiène et équipement</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">Le client s'engage à :</p>
                  <ul className="space-y-2 text-gray-700 ml-6 mb-4">
                    <li className="list-disc">
                      Porter des baskets propres, non utilisées à l'extérieur, pour raisons d'hygiène du centre. 
                      En cas d'oubli, le client pourra effectuer la séance en chaussettes, mais jamais pieds nus, également pour des raisons d'hygiène.
                    </li>
                    <li className="list-disc">Apporter sa propre serviette pour le visage ainsi qu'une serviette pour la douche.</li>
                    <li className="list-disc">Porter sa tenue EMS pour chaque séance (obligatoire).</li>
                  </ul>
                  <p className="text-gray-700 leading-relaxed">
                    Le centre The Hidden Garden EMS met à disposition des machines d'électrostimulation de dernier cri, 
                    ainsi que tout le matériel nécessaire au bon déroulement des séances et coachings. 
                    Tout est mis en œuvre pour garantir une expérience de qualité et optimale pour chaque client.
                  </p>
                </section>

                {/* Section 8 */}
                <section className="bg-white p-6 rounded-xl border border-gray-200">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Effets personnels</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Le centre The Hidden Garden EMS ne peut être tenu responsable en cas de perte, de vol ou de détérioration des effets personnels des clients.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Il est recommandé de ne pas apporter d'objets de valeur lors des séances. 
                    Chaque client reste entièrement responsable de ses effets personnels pendant toute la durée de sa présence au centre. 
                    Des casiers individuels sont mis à disposition dans la salle de sport afin que les affaires puissent être rangées pendant la séance.
                  </p>
                </section>

                {/* Section 9 */}
                <section className="bg-emerald-50/50 p-6 rounded-xl border border-emerald-100">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Moyens de paiement</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">Les moyens de paiement acceptés sont les suivants :</p>
                  <ul className="space-y-2 text-gray-700 ml-6">
                    <li className="list-disc">Espèces</li>
                    <li className="list-disc">Carte bancaire</li>
                    <li className="list-disc">Prélèvement automatique (obligatoire pour les abonnements)</li>
                    <li className="list-disc">Virement bancaire</li>
                  </ul>
                </section>

                {/* Section 10 */}
                <section className="bg-white p-6 rounded-xl border border-gray-200">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Prélèvement automatique</h2>
                  <p className="text-gray-700 leading-relaxed">
                    Pour les abonnements, le prélèvement automatique est obligatoire. 
                    Le client s'engage à fournir les informations bancaires nécessaires pour mettre en place ce mode de paiement.
                  </p>
                </section>

                {/* Section 11 */}
                <section className="bg-amber-50 p-6 rounded-xl border border-amber-200">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Impayés</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Tout impayé fera l'objet d'une facturation de cinq euros (5 €) pour frais de traitement comptable et administratif du dossier (non remboursables).
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    En cas de non-paiement d'une mensualité, ou de non-régularisation d'un impayé et des frais afférents dans un délai de 15 jours, 
                    l'accès au centre sera désactivé et l'abonnement souscrit sera résilié de plein droit par le centre. 
                    Le dossier sera alors mis en recouvrement.
                  </p>
                </section>

                {/* Section 12 */}
                <section className="bg-white p-6 rounded-xl border border-gray-200">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Mise en sommeil du contrat</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    L'abonnement pourra être temporairement « mis en sommeil » à la demande de l'adhérent, suivant les modalités prévues aux articles 12.1 des présentes conditions générales. 
                    Pendant la période de mise en sommeil, l'accès au centre sera désactivé. Une demande de résiliation ne pourra pas être faite durant cette période.
                  </p>

                  <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">12.1 Cause professionnelle :</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    En cas d'absence d'un (1) mois maximum pour raison professionnelles, l'adhérent pourra bénéficier d'une suspension partielle de ses prélèvements mensuels.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Pour cela, l'adhérent doit envoyer une lettre recommandée avec accusé de réception au siège social du centre The Hidden Garden EMS 
                    (8 Boulevard Émile Zola - 69600 Oullins) ou remettre son courrier en main propre à l'accueil du centre.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Ce courrier doit être envoyé au plus tard 15 jours après la date de rédaction et doit inclure un original de l'attestation de l'employeur 
                    précisant la durée du déplacement, avec la date de départ et de retour. Aucune mise en sommeil ne sera admise à posteriori.
                  </p>

                  <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">12.2 Vacances :</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    En période de vacances, le client a la possibilité de rattraper ses séances avant ou après ses congés personnels, 
                    et/ou avant ou après la période de fermeture du centre The Hidden Garden EMS.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    En cas exceptionnelles des vacances de 4 semaines, l'adhérent peut bénéficier, une fois par an, d'une suspension partielle 
                    de ses prélèvements mensuels pour une durée maximale d'un (1) mois.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Si le client se trouve dans ses six (6) premiers mois d'adhésion, la période d'engagement sera automatiquement prolongée d'un (1) mois 
                    afin de compenser la période suspendue.
                  </p>
                </section>

                {/* Section 13 */}
                <section className="bg-emerald-50/50 p-6 rounded-xl border border-emerald-100">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Report de l'abonnement</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Le report de l'abonnement est possible pour l'adhérent uniquement en cas de cause médicale. 
                    En cas d'absence d'un (1) mois minimum à six (6) mois maximum, pour raison médicale, 
                    l'adhérent pourra bénéficier d'un report de son abonnement.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Pour cela, l'adhérent doit envoyer une lettre recommandée avec accusé de réception au siège social du centre 
                    The Hidden Garden EMS (8 Boulevard Émile Zola - 69600 Oullins) ou remettre son courrier en main propre à l'accueil du centre, 
                    dans un délai de quinze (15) jours maximums après la date de prescription de l'arrêt.
                  </p>
                </section>

                {/* Section 14 */}
                <section className="bg-white p-6 rounded-xl border border-gray-200">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Responsabilité</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Conformément à l'article 37 de la loi du 16 Juillet 1984, relative à l'organisation et à la promotion des activités physiques et sportives, 
                    modifiée par la loi du 13 Juillet 1992, le club The Hidden Garden EMS a souscrit une assurance de responsabilité civile 
                    et multirisques professionnelle, pour son activité, celle de son personnel et de ses adhérents, auprès de la compagnie 
                    dont les coordonnées sont affichées au club.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Toute déclaration d'événement qui serait amenée à faire jouer les éventuelles garanties du club The Hidden Garden EMS 
                    devra faire l'objet d'une déclaration écrite, adressée au siège social du club (8 Boulevard Émile Zola - 69600 Oullins), 
                    par courrier recommandé avec accusé de réception, sous 48 heures maximum.
                  </p>
                </section>

                {/* Section 15 */}
                <section className="bg-emerald-50/50 p-6 rounded-xl border border-emerald-100">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">15. Médiation</h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    L'adhérent peut soumettre le différend relatif au présent contrat l'opposant au club The Hidden Garden EMS à un médiateur, 
                    conformément à l'article L. 612-1 du code de la consommation.
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    Pour ce faire, il peut remplir le formulaire prévu à cet effet sur le site internet de l'AME CONSO : www.mediationconso-ame.com, 
                    ou envoyer un courrier à l'AME CONSO, 11 Place Dauphine – 75001 PARIS.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Le club The Hidden Garden EMS et/ou l'adhérent restent libres d'accepter ou de refuser le recours à la médiation 
                    ainsi que, en cas de recours à la médiation, d'accepter ou de refuser la solution proposée par le médiateur.
                  </p>
                </section>

                {/* Section 16 */}
                <section className="bg-white p-6 rounded-xl border border-gray-200">
                  <h2 className="text-2xl font-bold text-gray-900 mb-4">16. Dispositif Bloctel</h2>
                  <p className="text-gray-700 leading-relaxed">
                    L'adhérent(e) qui ne souhaite pas faire l'objet d'un démarchage téléphonique déclare être informé(e) du droit de s'inscrire 
                    sur la liste d'opposition au démarchage téléphonique appelée Bloctel. L'adhérent(e) peut s'inscrire sur cette liste 
                    par voie électronique sur le site Internet bloctel.gouv.fr, ou par voie postale à l'adresse suivante : 
                    SAS OPPOSETEL, Service Bloctel, 6 rue Nicolas Siret, 10 000 Troyes.
                  </p>
                </section>
              </div>

              {/* Footer Note */}
              <div className="mt-12 bg-gradient-to-br from-emerald-700 to-emerald-900 p-6 rounded-2xl text-center">
                <p className="text-white font-medium">
                  Pour toute question concernant nos conditions générales de vente, 
                  n'hésitez pas à nous contacter.
                </p>
                <a 
                  href="tel:0659839111"
                  className="inline-block mt-4 bg-amber-400 hover:bg-amber-500 text-gray-900 px-6 py-3 rounded-full font-semibold transition-all duration-300"
                >
                  06 59 83 91 11
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
